import { motion } from 'framer-motion';

// Shared fade-up reveal. Wrap any element — it'll enter on viewport intersection once.
export default function Reveal({ children, delay = 0, as: Tag = 'div', ...rest }) {
  const MotionTag = motion[Tag];
  return (
    <MotionTag
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15, margin: '0px 0px -10% 0px' }}
      transition={{ duration: 0.7, delay, ease: 'easeOut' }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
}
